import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import Swal from 'sweetalert2';

export default function DisclaimerAd() {
    const [description, setDescription] = useState("");

    const getData = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/disclaimer/1`);
            if (res.status === 200) {
                setDescription(res.data.data);
            } else {
                setDescription([]);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (!description.description || description.description.trim() === "") {
                Swal.fire({
                    title: "Please enter content",
                    icon: "warning",
                });
                return;
            }

            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/disclaimer/1`,
                { description }
            );

            if (res.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Updated Successfully",
                    timer: 1500,
                });
            } else {
                Swal.fire({
                    title: "Update Failed",
                    icon: "error",
                });
            }
        } catch (err) {
            console.error("Update Error:", err);
            Swal.fire({
                title: "Something went wrong",
                icon: "error",
            });
        }
    };

    const modules = {
        toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
        ],
    };

    const handleChange = (value) => {
        setDescription((prevContent) => ({
            ...prevContent,
            description: value,
        }));
    };

    return (
        <div className="main-content">
            <div className="page-wrapper page-settings">
                <div className="content">
                    {/* Breadcrumb and Header Section with Card Shadow */}
                    <div
                        className="mb-4"
                        style={{
                            background: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            padding: "20px",
                        }}
                    >
                           <div className="content-page-header">
                            <h5>Disclaimer</h5>
                        </div>
                        <nav
                            aria-label="breadcrumb"
                            style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link> /
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Disclaimer
                                </li>
                            </ol>
                        </nav>
                     
                    </div>

                    {/* Editor Section with Card Shadow */}
                    <div
                        style={{
                            background: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            padding: "20px",
                        }}
                    >
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label
                                    style={{
                                        marginBottom: "12px",
                                        fontWeight: 600,
                                        color: "#0D233E",
                                        display: "block",
                                    }}
                                >
                                    Content
                                </label>
                                <ReactQuill
                                    theme="snow"
                                    modules={modules}
                                    value={description.description || ""}
                                    onChange={handleChange}
                                    style={{
                                        height: "350px",
                                        marginBottom: "50px",
                                    }}
                                />
                            </div>

                            <div className="btn-path">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    <i className="fas fa-save me-2"></i>
                                    Update
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
